import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders wizard modals at document.body so the fixed backdrop covers the
 * whole viewport. Ancestors inside the wizard shell use backdrop-filter,
 * which turns them into containing blocks for position: fixed and would
 * otherwise clip the overlay to that ancestor's box. The ob-page wrapper
 * keeps the wizard's CSS variables and scoped styles in effect.
 */
const ModalPortal: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  createPortal(<div className='ob-page'>{children}</div>, document.body);

export default ModalPortal;
